export default __webpack_public_path__ + "6499551437e6b7240dedbf2ddada62e2.svg";